<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: 'ItemsView',
    props: {
        loading: Boolean,
        planning: Boolean,
        department: Boolean,
        tableData: Array,
        selectedFS: null,
        selectedBudget: null,
        selectedApi: {
            type: Object,
            default: () => {}
        },
        selectedOPCR: null,
        selectedTransfer: null
    },
    components: {
        RawData
    },
    data(){
        return {
            filter: null,
            pageOptions: [5, 10, 25, 50, 100],
            currentPage: 1,
            perPage: 5,
            filterChildParent: 0,
            filterType: 'All'
        }
    },
    computed: {
        filteredItems() {
            let data = this.tableData;
            var total = this.currentPage * this.perPage;
            if(!this.planning && this.filterChildParent == 1){
                data = data.filter((item) => {
                    return item.mixParentId == 0 || item.mixParentId == null;
                });
            }
            if(!this.planning && this.filterChildParent == 2){
                data = data.filter((item) => {
                    return item.mixParentId > 0;
                });
            }
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            if(this.filterType != 'All'){
                data = data.filter((item) => {
                    return item.type == this.filterType;
                });
            }
            if(!this.planning){
                data = data.filter(item => { return item.showRow })
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows() {
            let data = this.tableData;
            if(!this.planning && this.filterChildParent == 1){
                data = data.filter((item) => {
                    return item.mixParentId == 0;
                });
            }
            if(!this.planning && this.filterChildParent == 2){
                data = data.filter((item) => {
                    return item.mixParentId > 0;
                });
            }
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            } 
            if(this.filterType != 'All'){
                data = data.filter((item) => {
                    return item.type == this.filterType;
                });
            }
            data = data.filter(item => { return item.showRow })
            return data.length;
        },
        selectedItems(){
            return this.tableData.filter(item => item.selected);
        },
    },
    methods: {
        returnToApi(){
            this.$emit('returnToApi')
        },
        totalResources() {
            var data = this.tableData;
            var sum = 0;
            data.forEach((item) => {
                if(!this.planning && !item.mixParentId) {
                    sum += parseFloat(item.totalWithInflation);
                }
                if(this.planning){
                    sum += parseFloat(item.totalWithInflation);
                }
            });
            return this.formatCurrency(sum);
        },
        addItem(){
            this.$emit('addItem');
        },
        updateItem(props, type = "edit"){
            this.$emit('updateItem', {props, type});
        },
        transferItem(row){
            this.$emit('transferItem', [row]);
        },
        transferSelected(){
            this.$emit('transferItem', this.selectedItems);
        },
        deleteItem(row){
            if(row.isModified && row.remainingQuantity == 0){
                return this.showToast("Cannot delete if remaining quantity is zero.", "error");
            }
            this.$emit('deleteItem', row);
        },
        postWork(){
            this.$emit('postWork')
        },
        resubmitItem(row){
            this.$emit('resubmitItem', row)
        },
        viewItemLogs(row){
            this.$emit('viewItemLogs', row)
        },
        updateMixItem(row){
            this.$emit('updateMixItem', row)
        },
        transferToMother(row){
            this.$emit('transferToMother', row)
        },
        createMixItem(row){
            this.$emit('createMixItem', row)
        },
        showChildItems(row){
            row.showChild = !row.showChild;
            row.kids.map(item => {
                let filter = this.tableData.find(i => i.id == item);
                filter.showRow = row.showChild;
            })
        },
        generatePPMP(type){
            this.$emit('generatePPMP', type)
        },
        generateIndicativePR(){
            this.$emit('generateIndicativePR', this.selectedApi.id)
        },
        deleteAllItems(){
            this.$emit('deleteAllItems')
        },
        hasFS(item){
            if(this.planning){
                return item.financeTemplateBudgetItem && item.financeTemplateBudgetItem.fundSource;
            } else {
                return item.deliveryUnitBudgetItem && item.deliveryUnitBudgetItem.fundSource;
            }
        }
    }
}
</script>
<template>
    <div>
        <div class="row">
            <b-col sm="6">
                <div class="d-flex align-items-center">
                    <a
                        href="javascript:void(0);"
                        class="me-1"
                        @click="returnToApi"
                        ><i
                            class="
                                bx bx-left-arrow-alt
                                fs-2
                            "
                        ></i
                    ></a>
                    <div>
                        <h4 class="m-0">
                            {{ selectedApi.name }}'s Items
                        </h4>
                        <template v-if="planning && !department">
                            <span v-if="selectedApi.departmentPlanningApiId" class="text-yellow">From Department: {{selectedApi.departmentName}}</span>
                        </template>
                    </div>
                </div>
            </b-col>
            <b-col sm="6" class="text-right">
                <h4 class="text-muted mb-0">
                    <div class="">
                        Total:
                        <b class="text-warning">{{ totalResources() }}</b>
                    </div>
                </h4>
            </b-col>
        </div>
        <b-row>
            <b-col sm="12" class="mt-2">
                <div class="row">
                    <div class="col-md-6 d-flex">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter me-1"
                        >
                            <label
                                class="
                                    d-inline-flex
                                    align-items-center
                                    mb-0
                                "
                            >
                                <b-form-input
                                    autocomplete="off"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Search Items..."
                                    class="form-control"
                                ></b-form-input>
                            </label>
                        </div>
                        <div
                            id="tickets-table_length"
                            class="dataTables_length"
                        >
                            <label
                                class="
                                    d-inline-flex
                                    align-items-center
                                    mb-0
                                "
                            >
                                <b-form-select
                                    class="form-select"
                                    v-model="perPage"
                                    size="sm"
                                    :options="pageOptions"
                                ></b-form-select>
                            </label>
                        </div>
                        <button v-if="selectedItems.length" class="btn btn-secondary ms-1 d-flex align-items-center" @click="transferSelected">
                            <i class="bx bx-cog font-size-18"></i> Transfer Selected<span class="badge bg-danger">{{selectedItems.length}}</span>
                        </button>
                        <button v-if="$store.state.decrypt.isAdmin()" class="btn btn-danger ms-1 d-flex align-items-center" @click="deleteAllItems">
                            <i class="bx bx-trash font-size-18"></i> Delete All Items
                        </button>
                    </div>
                    <div class="col-md-6 text-right">
                        <template v-if="planning">
                            <button 
                                class="btn btn-info d-flex align-items-center float-end"
                                @click="addItem"
                                v-if="(selectedOPCR && selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')) && !selectedApi.departmentPlanningApiId"
                            >
                                <i class="bx bx-plus"></i>
                                Create New
                            </button>
                            <!-- <button 
                                class="btn btn-purple d-flex align-items-center float-end me-1"
                                @click="generateIndicativePR"
                                v-if="!department"
                            >
                                <i class="bx bx-printer me-1"></i>
                                Generate Indicative PR
                            </button> -->
                        </template>
                        <div class="d-flex flex-row-reverse">
                            <div class="d-flex">
                                <select class="form-select me-2" style="width:120px;" v-model="filterType" >
                                    <option>All</option>
                                    <option>CSE</option>
                                    <option>NON-CSE</option>
                                </select>
                                <template v-if="!planning">
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        right
                                        variant="outline-dark"
                                        toggle-class="text-decoration-none"
                                        menu-class="dropdown-menu-end"
                                        no-caret
                                        v-if="$store.state.decrypt.isAdmin()"
                                    >
                                        <template #button-content>
                                            <i class="bx bx-filter"></i>
                                        </template>
                                        <b-dropdown-item @click="filterChildParent = 0"><span :class="{'text-success': filterChildParent == 0}">All</span></b-dropdown-item>
                                        <b-dropdown-item @click="filterChildParent = 1"><span :class="{'text-success': filterChildParent == 1}">Parent</span></b-dropdown-item>
                                        <b-dropdown-item @click="filterChildParent = 2"><span :class="{'text-success': filterChildParent == 2}">Child</span></b-dropdown-item>
                                    </b-dropdown>
                                    <button 
                                        class="btn btn-info d-flex align-items-center float-end ms-1"
                                        @click="addItem"
                                        v-if="(!selectedApi.status.toUpperCase().includes('POST') && !selectedApi.status.toUpperCase().includes('APPROVED')) || this.$store.state.decrypt.isAdmin()"
                                    >
                                        <i class="bx bx-plus"></i>
                                        Create New
                                    </button>
                                    <button 
                                        class="btn btn-success d-flex align-items-center float-end"
                                        @click="postWork"
                                        v-if="selectedApi.status !== 'POSTED' && selectedApi.status !==  'APPROVED'"
                                    >
                                        <i class="bx bx-check me-1"></i>
                                        Post this Work
                                    </button>
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        right
                                        variant="purple"
                                        toggle-class="text-decoration-none"
                                        menu-class="dropdown-menu"
                                        class="ms-1"
                                        no-caret
                                    >
                                        <template #button-content>
                                            <i class="bx bx-printer me-1"></i>
                                            Generate PPMP
                                        </template>
                                        <b-dropdown-item @click="generatePPMP(1)">V1</b-dropdown-item>
                                        <b-dropdown-item @click="generatePPMP(2)">V2</b-dropdown-item>
                                    </b-dropdown>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div>
                            <div class="table-responsive">
                                <table
                                    class="
                                        table
                                        project-list-table
                                        table-centered
                                        table-borderless
                                        align-middle
                                    "
                                >
                                    <thead>
                                        <tr>
                                            <th width="20px" v-if="!planning"></th>
                                            <th scope="col">
                                                Item Name
                                            </th>
                                            <th
                                                scope="col"
                                                width="150px"
                                                class="text-center"
                                            >
                                                Quantity
                                            </th>
                                            <th
                                                scope="col"
                                                width="170px"
                                            >
                                                Unit Cost
                                            </th>
                                            <th
                                                scope="col"
                                                width="170px"
                                            >
                                                Total
                                            </th>
                                            <th
                                                scope="col"
                                                width="100px"
                                                class="text-center"
                                            >
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="loading">
                                            <td colspan="100%">
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <div class="preloader-component me-2">
                                                        <div class="status">
                                                            <div class="spinner-chase w-20px h-20px">
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <strong>Loading...</strong>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="tableData.length == 0 && !loading">
                                            <td
                                                colspan="100%"
                                                class="text-muted text-center"
                                            >
                                                <i class="dripicons-warning me-1"></i>No data found
                                            </td>
                                        </tr>
                                        <tr v-if="filteredItems.length == 0 && !loading && tableData.length > 0">
                                            <td
                                                colspan="100%"
                                                class="text-muted text-center"
                                            >
                                                <i class="dripicons-warning me-1"></i>Search not found
                                            </td>
                                        </tr>
                                        <tr 
                                            v-for="x in filteredItems" 
                                            :key="x.id"
                                            :ref="`resource-tr-${x.id}`"
                                            :style="!planning && `background-color: transparent; box-shadow: none;`"
                                        >
                                            <template v-if="planning || (!planning && x.showRow)">
                                                <td v-if="!planning && x.mixParentId > 0"><i class="bx bx-right-arrow-alt"></i></td>
                                                <td 
                                                    class="border border-end-0 position-relative"
                                                    :colspan="planning ? 1 : x.mixParentId > 0 ? 1 : 2"
                                                    :class="{
                                                        'bg-table-tr': !planning,
                                                        'border-success': !planning && x.technicalReviewStatus.toUpperCase().includes('APPROVED'),
                                                        'border-warning': !planning && x.technicalReviewStatus.toUpperCase().includes('RETURN'),
                                                    }"
                                                >
                                                    <RawData :data="x"/>
                                                    <div class="child-view" v-if="!planning && x.isMixed && (!x.mixParentId || x.mixParentId == 0) && x.kids.length" @click="showChildItems(x)">
                                                        <a href="javascript:void(0);" class="font-size-20"><i class="bx bx-chevron-down rotate" :class="{'rotate-n90': !x.showChild}"></i></a>
                                                    </div>
                                                    <div class="d-flex align-items-center">
                                                        <!-- <div class="me-2" v-if="!planning">
                                                            <div 
                                                                style="height:50px;width:50px;"
                                                                class="bg-secondary cursor-pointer"
                                                                @click="updateProfile(x)"
                                                            >
                                                                <img 
                                                                    :src="x.thumbnailUrl"
                                                                    v-if="x.thumbnail"
                                                                    class="img-fluid"
                                                                    style="height: 50px;width: 50px;"
                                                                />
                                                            </div>
                                                        </div> -->
                                                        <div class="ms-2">
                                                            <div :class="{'form-check form-checkbox-outline form-check-success': !planning && $store.state.decrypt.isAdmin()}">
                                                                <input
                                                                    autocomplete="off"
                                                                    class="form-check-input"
                                                                    type="checkbox"
                                                                    :id="`selected-${x.id}`"
                                                                    v-model="x.selected"
                                                                    v-if="!planning && $store.state.decrypt.isAdmin()"
                                                                />
                                                                <label class="form-check-label" :for="`selected-${x.id}`">
                                                                    {{ x.itemName }}
                                                                </label>
                                                            </div>
                                                            <small>{{x.description}}</small>
                                                            <small class="d-block text-yellow" v-if="x.note">({{x.note}})</small>
                                                            <div>
                                                                <small>
                                                                    <i>{{ x.itemCategory.name || x.itemCategory }}</i>
                                                                    <span class="text-warning ms-1">[{{x.isProcurable ? 'Procurable' : 'Non-procurable' }}]</span>
                                                                    <span class="text-warning ms-1" v-if="x.isMixed">[Mixed]</span>
                                                                    <span class="text-warning ms-1" >[{{x.type}}]</span>
                                                                </small>
                                                            </div>
                                                            <div class="d-inline align-items-center mb-1">
                                                                <span class="badge bg-secondary text-white py-1 px-2 me-2" v-if="hasFS(x)">
                                                                    {{ planning ? x.financeTemplateBudgetItem.fundSource : x.deliveryUnitBudgetItem.fundSource }}
                                                                </span>
                                                                <span class="badge bg-purple text-white py-1 px-2 me-2">
                                                                    {{  planning ? x.financeTemplateBudgetItem.fundClass : x.deliveryUnitBudgetItem.fundClass }}
                                                                </span>
                                                                <span class="badge bg-success text-white py-1 px-2 me-2">
                                                                    {{  planning ? x.financeTemplateBudgetItem.accountGroup : x.deliveryUnitBudgetItem.accountGroup }}
                                                                </span>
                                                            </div>
                                                            <div class="mt-2" v-if="!planning">
                                                                <div class="form-check form-checkbox-outline form-check-success mb-0">
                                                                    <input
                                                                        autocomplete="off"
                                                                        class="form-check-input"
                                                                        type="checkbox"
                                                                        :id="`notify-${x.id}`"
                                                                        v-model="x.notify"
                                                                        @click="notifyForUpdates(x)"
                                                                    />&nbsp;&nbsp;
                                                                    <label class="form-check-label" :for="`notify-${x.id}`">Notify for Item Updates</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td 
                                                    class="border border-start-0 border-end-0 text-center"
                                                    :class="{
                                                        'bg-table-tr': !planning,
                                                        'border-success': !planning && x.technicalReviewStatus.toUpperCase().includes('APPROVED'),
                                                        'border-warning': !planning && x.technicalReviewStatus.toUpperCase().includes('RETURN'),
                                                    }"
                                                >
                                                    <template v-if="planning">
                                                        {{ numberWithCommas(x.totalQuantity) }}
                                                    </template>
                                                    <template v-else>
                                                        {{ numberWithCommas(x.totalQuantity) }}
                                                        <small class="d-block text-danger" v-if="x.isModified && x.totalQuantity != x.remainingQuantity">({{numberWithCommas(x.totalQuantity - x.remainingQuantity)}})</small>
                                                        <small class="d-block text-white" v-if="x.isModified && x.totalQuantity != x.remainingQuantity">{{numberWithCommas(x.remainingQuantity)}}</small>
                                                    </template>
                                                </td>
                                                <td 
                                                    class="border border-start-0 border-end-0"
                                                    :class="{
                                                        'bg-table-tr': !planning,
                                                        'border-success': !planning && x.technicalReviewStatus.toUpperCase().includes('APPROVED'),
                                                        'border-warning': !planning && x.technicalReviewStatus.toUpperCase().includes('RETURN'),
                                                    }"
                                                >
                                                    <template v-if="planning">
                                                        {{ formatCurrency(department ? x.unitCost : x.inflatedUnitCost) }}
                                                    </template>
                                                    <template v-else>
                                                        {{ formatCurrency(x.unitCostWithInflation) }}
                                                    </template>
                                                    <div v-if="x.totalInflation != 0">
                                                        <small class="d-block">Orig. Cost: <span class="text-warning">{{formatCurrency(department ? x.baseUnitCost : x.unitCost)}}</span></small>
                                                        <small class="d-block" v-if="!department">Inflation: {{x.unitCostWithInflation ? formatCurrency(x.unitCostWithInflation) : formatCurrency(parseFloat(x.inflatedUnitCost) - parseFloat(x.unitCost))}}</small>
                                                        <small class="d-block" v-else>Inflation: {{formatCurrency(x.unitCostInflation)}}</small>
                                                    </div>
                                                </td>
                                                <td 
                                                    class="border border-start-0 border-end-0"
                                                    :class="{
                                                        'bg-table-tr': !planning,
                                                        'border-success': !planning && x.technicalReviewStatus.toUpperCase().includes('APPROVED'),
                                                        'border-warning': !planning && x.technicalReviewStatus.toUpperCase().includes('RETURN'),
                                                    }"
                                                >
                                                    {{ formatCurrency(parseFloat(x.totalWithInflation)) }}
                                                    <div v-if="x.totalInflation != 0">
                                                        <small>Inflation: {{formatCurrency(x.totalInflation)}}</small>
                                                    </div>
                                                    <template v-if="!planning">
                                                        <div v-if="x.isModified && x.totalQuantity != x.remainingQuantity">
                                                            <small>Remaining: <span class="text-white font-weight-bold">{{formatCurrency(x.remainingQuantity * x.unitCostWithInflation)}}</span></small>
                                                        </div>
                                                        <div v-if="x.isMixed">
                                                            <small class="text-warning d-flex cursor-pointer hover-underline" :id="`mixed-parent-${x.id}`">
                                                                <span class="me-1">Mixed Amt. Details</span>
                                                                <div 
                                                                    class="border border-warning d-flex align-items-center justify-content-center" 
                                                                    style="width:15px;height:15px;border-radius:50%;"
                                                                >
                                                                    <i class="bx bx-question-mark"></i>
                                                                </div> 
                                                            </small>
                                                            <b-popover 
                                                                :target="`mixed-parent-${x.id}`"
                                                                triggers="hover blur"
                                                                placement="left"
                                                            >
                                                                <div>
                                                                    <p class="mb-0">Mixed Child Total:</p>
                                                                    <p class="text-info ms-3"> {{formatCurrency(x.totalWithInflation - x.remaining)}}</p>
                                                                </div>
                                                                <div>
                                                                    <p class="mb-0">Mixed Amount Remaining:</p>
                                                                    <p class="text-warning ms-3"> {{formatCurrency(x.remaining)}}</p>
                                                                </div>
                                                            </b-popover>
                                                        </div>
                                                    </template>
                                                </td>
                                                <td 
                                                    class="text-center border border-start-0"
                                                    :class="{
                                                        'bg-table-tr': !planning,
                                                        'border-success': !planning && x.technicalReviewStatus.toUpperCase().includes('APPROVED'),
                                                        'border-warning': !planning && x.technicalReviewStatus.toUpperCase().includes('RETURN'),
                                                    }"
                                                >
                                                    <b-dropdown
                                                        class="card-drop"
                                                        menu-class="dropdown-menu-end"
                                                        variant="white"
                                                        toggle-class="p-0"
                                                    >
                                                        <template v-slot:button-content>
                                                            <i class="mdi mdi-dots-horizontal font-size-18"></i>
                                                        </template>
                                                        <template v-if="!planning">
                                                            <b-dropdown-item
                                                                @click="resubmitItem(x)"
                                                                variant="success"
                                                                v-if="x.technicalReviewStatus.toUpperCase().includes('RETURN') && !x.isMixed && (!x.mixParentId || x.mixParentId == 0)"
                                                            >
                                                                <i class="bx bx-check font-size-18 me-1"></i>Resubmit Item
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                @click="viewItemLogs(x)"
                                                                variant="dark"
                                                            >
                                                                <i class="bx bx-menu-alt-right font-size-18 me-1"></i>View Logs
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                @click="transferItem(x)"
                                                                v-if="$store.state.decrypt.isAdmin()"
                                                                variant="success"
                                                                >
                                                                <i class="bx bx-send font-size-18 me-1"></i>Transfer to another API
                                                            </b-dropdown-item>
                                                            <template v-if="!x.mixParentId || x.mixParentId == 0">
                                                                <b-dropdown-item
                                                                    @click="updateItem(x)"
                                                                    v-if="
                                                                        (selectedApi.status !== 'POSTED' && selectedApi.status !== 'APPROVED') ||
                                                                        (x.technicalReviewStatus.toUpperCase().includes('RETURN') && !x.isMixed  && (!x.mixParentId || x.mixParentId == 0)) || 
                                                                        $store.state.decrypt.isAdmin()
                                                                    "
                                                                    variant="dark"
                                                                >
                                                                    <i class="bx bx-edit font-size-18 me-1"></i>Edit
                                                                </b-dropdown-item>
                                                            </template>
                                                            <template v-if="x.mixParentId && x.mixParentId > 0">
                                                                <b-dropdown-item
                                                                    @click="updateMixItem(x)"
                                                                    
                                                                    variant="dark"
                                                                >
                                                                    <i class="bx bx-edit font-size-18 me-1"></i>Edit
                                                                </b-dropdown-item>
                                                            </template>
                                                            <b-dropdown-item
                                                                @click="updateItem(x, 'view')"
                                                                variant="dark"
                                                            >
                                                                <i class="bx bx-food-menu font-size-18 me-1"></i>View Details
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                @click="transferToMother(x)"
                                                                v-if="$store.state.decrypt.isAdmin()"
                                                                variant="dark"
                                                            >
                                                                <i class="bx bx-chevron-left font-size-18 me-1"></i>Transfer to a Mother Resource
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                v-if="x.isMixed && selectedTransfer && !selectedTransfer.id"
                                                                @click="createMixItem(x)"
                                                                variant="primary"
                                                            >
                                                                <i class="bx bx-plus font-size-18 me-1"></i> Create Item
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                v-if="
                                                                    (selectedApi.status !== 'POSTED' && selectedApi.status !== 'APPROVED') ||
                                                                    (x.technicalReviewStatus.toUpperCase().includes('RETURN') && !x.isMixed  && (!x.mixParentId || x.mixParentId == 0)) || 
                                                                    x.mixParentId && x.mixParentId > 0 ||
                                                                    $store.state.decrypt.isAdmin()
                                                                "
                                                                @click="deleteItem(x)"
                                                                variant="danger"
                                                            >
                                                                <i class="mdi mdi-trash-can font-size-18 me-1"></i>Delete 
                                                            </b-dropdown-item>
                                                        </template>
                                                        <template v-else>
                                                            <b-dropdown-item
                                                                v-if="((selectedOPCR && selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')) && !selectedApi.departmentPlanningApiId) || $store.state.decrypt.isAdmin()"
                                                                @click="updateItem(x)"
                                                                variant="dark"
                                                            >
                                                                <i class="bx bx-edit font-size-18 me-1"></i>Edit
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                @click="updateItem(x, 'view')"
                                                                variant="dark"
                                                            >
                                                                <i class="bx bx-food-menu font-size-18 me-1"></i>View Details
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                v-if="(selectedOPCR && selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')) && !selectedApi.departmentPlanningApiId"
                                                                @click="transferItem(x)"
                                                                variant="success"
                                                            >
                                                                <i class="bx bx-send font-size-18 me-1"></i>Transfer to another API
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                v-if="(selectedOPCR && selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')) && !selectedApi.departmentPlanningApiId"
                                                                @click="deleteItem(x)"
                                                                variant="danger"
                                                            >
                                                                <i class="mdi mdi-trash-can font-size-18 me-1"></i>Delete
                                                            </b-dropdown-item>
                                                        </template>
                                                    </b-dropdown>
                                                </td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col mb-3">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                            <ul class="pagination pagination-rounded mb-0">
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<style lang="scss">
.child-view{
    position: absolute;
    bottom: -10px;
    left: -2px;
    background: var(--bs-indigo);
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    a{
        color: #fff;
        height: 100%;
    }
    
}
</style>